/**
 * ¿Son **de lo mismo** estas dos claves?
 *
 * Una «clave» dice de qué va un dato: de qué año, de qué pestaña, de qué empleado y qué semana.
 * Comparar la de una respuesta con la de lo que se está mirando es lo único que distingue «esto es
 * lo que he pedido» de «esto es lo de antes, que ha llegado tarde». La comparación está aquí, sola,
 * porque la necesitan dos cosas distintas y no puede haber dos versiones de ella: el carril
 * (`carrilPeticiones`) la usa para **descartar** una respuesta caducada al llegar, y
 * `respuestaVigente` para **no pintar** lo que ya no es de lo que se mira.
 *
 * La clave puede ser un valor suelto o una lista de valores, y se comparan uno a uno:
 *
 *   mismaClave([b.anio, b.pestana], [this.anio, this.pestana])
 *   mismaClave(res.anio, this.anio)
 *
 * Un `null`/`undefined` **en la clave de la pantalla** significa «todavía no se sabe de qué va
 * esto» —la primera carga de «Mis vacaciones» no conoce el año hasta que el servidor lo dice— y
 * ahí manda la respuesta: si no, la pantalla arrancaría enseñando que no hay nada. Quien use una
 * clave que puede faltar porque lo que hay en pantalla **no sirve** (una fila de fechas a medias)
 * tiene que descartarla él antes de llamar: para esta función «no se sabe» no es «no vale».
 *
 * @param deLaRespuesta de qué es el dato que ha llegado: lo que él mismo declara
 * @param enPantalla de qué es lo que se está mirando ahora
 * @returns `true` si el dato es de lo que se mira
 */
export default function mismaClave(deLaRespuesta, enPantalla) {
  const suyas = [].concat(deLaRespuesta);
  const mirando = [].concat(enPantalla);
  for (let i = 0; i < mirando.length; i++) {
    // Se compara con `!==` a propósito, sin convertir: el año llega como número de los dos lados
    // —el `<select>` lo pasa por `parseInt`— y una comparación laxa taparía que alguna vez no.
    if (mirando[i] != null && suyas[i] !== mirando[i]) return false;
  }
  return true;
}
